export default {
  methods: {
    // 跳过
    jumpProgress(spuInfo) {
      this.$confirm((<div class="jsx-content">
        是否跳过产品文案节点？
      </div>), '跳过')
      .then(_=>{
        const loading = this.$loading({
          target: '.app-main',
          lock: true,
        });
        const params = {
          params: {
            spuId: spuInfo.dataId,
          }
        };
        this.$q.newProduct.skipTask(params)
          .then(({success}) => {
            if (success) {
              this.$notify.success({
                title: '提示',
                message: '已完成',
              });
            }
          })
          .finally(() => {
            this.updateProgressInfo();
            loading.close();
          });
      })
      .catch(_=> {});
    },
    // 跳过
    jumpProgress2(spuId) {
      this.$confirm((<div class="jsx-content">
        是否跳过设计节点？
      </div>), '跳过')
      .then(_=>{
        const loading = this.$loading({
          target: '.app-main',
          lock: true,
        });
        const params = {
          params: {
            spuId
          }
        };
        this.$q.newProduct.skipDesignTask(params)
          .then(({success}) => {
            if (success) {
              this.$notify.success({
                title: '提示',
                message: '已完成',
              });
            }
          })
          .finally(() => {
            this.updateProgressInfo();
            loading.close();
          });
      })
      .catch(_=> {});
    },
    // 跳过
    jumpProgress3(spuInfo) {
      this.$confirm((<div class="jsx-content">
        是否跳过产品资料节点？
      </div>), '跳过')
      .then(_=>{
        const loading = this.$loading({
          target: '.app-main',
          lock: true,
        });
        const params = {
          params: {
            spuId: spuInfo.dataId,
          }
        };
        this.$q.newProduct.proMaterialTask(params)
          .then(({success}) => {
            if (success) {
              this.$notify.success({
                title: '提示',
                message: '已完成',
              });
            }
          })
          .finally(() => {
            this.updateProgressInfo();
            loading.close();
          });
      })
      .catch(_=> {});
    },
    // 跳过
    jumpProgress4(spuInfo, index, name) {
      console.log('spuInfo',spuInfo);
      this.$confirm((<div class="jsx-content">
        是否跳过样{name}节点？
      </div>), '跳过')
      .then(_=>{
        const loading = this.$loading({
          target: '.app-main',
          lock: true,
        });
        const params = {
          params: {
            spuId: spuInfo.dataId,
            curTaskId: this.currentStep,
            skipTaskId: index == 3 ? 111 : this.currentStep
          }
        };
        this.$q.newProduct.skipNode(params)
          .then(({success}) => {
            if (success) {
              this.$notify.success({
                title: '提示',
                message: '已完成',
              });
            }
          })
          .finally(() => {
            this.updateProgressInfo();
            loading.close();
          });
      })
      .catch(_=> {});
    },
  }
}